<template>
  <section id="state-overall">
    <figure class="chart">
      <div class="fish-ani">
        <svg class="fish" id="fish">
          <path
            id="fish2"
            d="m 172.04828,20.913839 c 0.0489,-0.444179 -0.2178,-0.896934 -1.01784,-1.415715 -0.72801,-0.475049 -1.4826,-0.932948 -2.2149,-1.401138 -1.6035,-1.028129 -3.29018,-1.969653 -4.89798,-3.079244 -4.67074,-3.24131 -10.22127,-4.404923 -15.76322,-5.1509392 -2.27235,-0.286401 -4.81223,-0.168925 -6.72186,-1.574351 -1.48174,-1.081294 -4.04993,-4.828523 -6.86506,-6.456038 -0.4862,-0.290688 -2.77227,-1.44486897 -2.77227,-1.44486897 0,0 1.30939,3.55000597 1.60951,4.26429497 0.69542,1.644664 -0.38158,3.063809 -0.83262,4.642447 -0.29069,1.0418502 2.13772,0.8129002 2.26463,1.7827212 0.18179,1.432007 -4.15197,1.936211 -6.59152,2.417263 -3.65634,0.715146 -7.91635,2.082841 -11.56925,0.884071 -4.3046,-1.38313 -7.37269,-4.129669 -10.46566,-7.2354952 1.43801,6.7252892 5.4382,10.6028562 5.6157,11.4226162 0.18607,0.905509 -0.45961,1.091584 -1.04099,1.682394 -1.28967,1.265655 -6.91566,7.731125 -6.93366,9.781383 1.61379,-0.247815 3.56115,-1.660957 4.9803,-2.485862 1.58035,-0.905509 7.60593,-5.373029 9.29347,-6.065023 0.38587,-0.160351 5.0549,-1.531476 5.09434,-0.932949 0.0695,0.932949 -0.30784,1.137031 -0.18436,1.527189 0.22638,0.746016 1.44144,1.465449 2.02282,1.985088 1.50918,1.292237 3.21044,2.42841 4.27373,4.156252 1.49203,2.401827 1.55805,4.999163 1.98251,7.677102 0.99469,-0.111473 2.0091,-2.17545 2.55961,-2.992638 0.51278,-0.772598 2.38639,-4.07136 3.09725,-4.275442 0.67227,-0.204082 2.75511,0.958673 3.50284,1.180763 2.85973,0.848057 5.644,1.353976 8.56032,1.353976 3.50799,0.0094 12.726,0.258104 19.55505,-4.800226 0.75545,-0.567658 2.55703,-2.731104 2.55703,-2.731104 0,0 -0.37644,-0.577091 -1.04785,-0.790605 0.89779,-0.584808 1.8659,-1.211633 1.94993,-1.925922 z"
            style="fill:#183a70;fill-opacity:1"
            inkscape:connector-curvature="0"
            sodipodi:nodetypes="cccccccccccccccccccccccccccccccc" />
          <path
            sodipodi:nodetypes="cccccccccccccccccccccccccccccccc"
            inkscape:connector-curvature="0"
            style="fill:#183a70;fill-opacity:1"
            d="m 234.99441,42.953992 c 0.0489,-0.44418 -0.2178,-0.896934 -1.01784,-1.415715 -0.72801,-0.47505 -1.4826,-0.932949 -2.2149,-1.401138 -1.6035,-1.02813 -3.29018,-1.969653 -4.89798,-3.079245 -4.67074,-3.24131 -10.22127,-4.404923 -15.76322,-5.150939 -2.27235,-0.286401 -4.81223,-0.168925 -6.72186,-1.574351 -1.48174,-1.081294 -4.04993,-4.828523 -6.86506,-6.456038 -0.4862,-0.290688 -2.77227,-1.444869 -2.77227,-1.444869 0,0 1.30939,3.550006 1.60951,4.264295 0.69542,1.644664 -0.38158,3.063809 -0.83262,4.642447 -0.29069,1.04185 2.13772,0.8129 2.26463,1.782721 0.18179,1.432007 -4.15197,1.936211 -6.59152,2.417263 -3.65634,0.715146 -7.91635,2.082842 -11.56925,0.884072 -4.3046,-1.383131 -7.37269,-4.12967 -10.46566,-7.235496 1.43801,6.725289 5.4382,10.602857 5.6157,11.422617 0.18607,0.905508 -0.45961,1.091583 -1.04099,1.682394 -1.28967,1.265654 -6.91566,7.731125 -6.93366,9.781382 1.61379,-0.247815 3.56115,-1.660957 4.9803,-2.485862 1.58035,-0.905509 7.60593,-5.373029 9.29347,-6.065023 0.38587,-0.160351 5.0549,-1.531476 5.09434,-0.932948 0.0695,0.932948 -0.30784,1.137031 -0.18436,1.527188 0.22638,0.746016 1.44144,1.46545 2.02282,1.985088 1.50918,1.292237 3.21044,2.42841 4.27373,4.156252 1.49203,2.401827 1.55805,4.999163 1.98251,7.677102 0.99469,-0.111473 2.0091,-2.17545 2.55961,-2.992638 0.51278,-0.772598 2.38639,-4.071359 3.09725,-4.275442 0.67227,-0.204082 2.75511,0.958673 3.50284,1.180763 2.85973,0.848057 5.644,1.353976 8.56032,1.353976 3.50799,0.0094 12.726,0.258104 19.55505,-4.800226 0.75545,-0.567658 2.55703,-2.731104 2.55703,-2.731104 0,0 -0.37644,-0.57709 -1.04785,-0.790605 0.89779,-0.584808 1.8659,-1.211633 1.94993,-1.925921 z"
            id="fish3" />
          <path
            id="fish6"
            d="m 200.07076,80.737109 c 0.0489,-0.44418 -0.2178,-0.896934 -1.01784,-1.415715 -0.72801,-0.47505 -1.4826,-0.932949 -2.2149,-1.401138 -1.6035,-1.02813 -3.29018,-1.969653 -4.89798,-3.079245 -4.67074,-3.24131 -10.22127,-4.404923 -15.76322,-5.150939 -2.27235,-0.286401 -4.81223,-0.168925 -6.72186,-1.574351 -1.48174,-1.081294 -4.04993,-4.828523 -6.86506,-6.456038 -0.4862,-0.290688 -2.77227,-1.444869 -2.77227,-1.444869 0,0 1.30939,3.550006 1.60951,4.264295 0.69542,1.644664 -0.38158,3.063809 -0.83262,4.642447 -0.29069,1.04185 2.13772,0.8129 2.26463,1.782721 0.18179,1.432007 -4.15197,1.936211 -6.59152,2.417263 -3.65634,0.715146 -7.91635,2.082842 -11.56925,0.884072 -4.3046,-1.383131 -7.37269,-4.12967 -10.46566,-7.235496 1.43801,6.725289 5.4382,10.602857 5.6157,11.422617 0.18607,0.905508 -0.45961,1.091583 -1.04099,1.682394 -1.28967,1.265654 -6.91566,7.731125 -6.93366,9.781382 1.61379,-0.247815 3.56115,-1.660957 4.9803,-2.485862 1.58035,-0.905509 7.60593,-5.373029 9.29347,-6.065023 0.38587,-0.160351 5.0549,-1.531476 5.09434,-0.932948 0.0695,0.932948 -0.30784,1.137031 -0.18436,1.527188 0.22638,0.746016 1.44144,1.46545 2.02282,1.985088 1.50918,1.292237 3.21044,2.42841 4.27373,4.156252 1.49203,2.401827 1.55805,4.999163 1.98251,7.677102 0.99469,-0.111473 2.0091,-2.17545 2.55961,-2.992638 0.51278,-0.772598 2.38639,-4.071359 3.09725,-4.275442 0.67227,-0.204082 2.75511,0.958673 3.50284,1.180763 2.85973,0.848057 5.644,1.353976 8.56032,1.353976 3.50799,0.0094 12.726,0.258104 19.55505,-4.800226 0.75545,-0.567658 2.55703,-2.731104 2.55703,-2.731104 0,0 -0.37644,-0.57709 -1.04785,-0.790605 0.89779,-0.584808 1.8659,-1.211633 1.94993,-1.925921 z"
            style="fill:#183a70;fill-opacity:1"
            inkscape:connector-curvature="0"
            sodipodi:nodetypes="cccccccccccccccccccccccccccccccc" />
          <path
            sodipodi:nodetypes="cccccccccccccccccccccccccccccccc"
            inkscape:connector-curvature="0"
            style="fill:#183a70;fill-opacity:1"
            d="m 77.275623,89.018799 c 0.0489,-0.44418 -0.2178,-0.896934 -1.01784,-1.415715 -0.72801,-0.47505 -1.4826,-0.932949 -2.2149,-1.401138 -1.6035,-1.02813 -3.29018,-1.969653 -4.89798,-3.079245 -4.67074,-3.24131 -10.22127,-4.404923 -15.76322,-5.150939 -2.272347,-0.286401 -4.812227,-0.168925 -6.721857,-1.574351 -1.48174,-1.081294 -4.04993,-4.828523 -6.86506,-6.456038 -0.4862,-0.290688 -2.77227,-1.444869 -2.77227,-1.444869 0,0 1.30939,3.550006 1.60951,4.264295 0.69542,1.644664 -0.38158,3.063809 -0.83262,4.642447 -0.29069,1.04185 2.13772,0.8129 2.26463,1.782721 0.18179,1.432007 -4.15197,1.936211 -6.59152,2.417263 -3.65634,0.715146 -7.91635,2.082842 -11.56925,0.884072 -4.3046,-1.383131 -7.37269,-4.12967 -10.46566,-7.235496 1.43801,6.725289 5.4382,10.602857 5.6157,11.422617 0.18607,0.905508 -0.45961,1.091583 -1.04099,1.682394 -1.28967,1.265654 -6.9156603,7.731122 -6.9336603,9.781382 1.6137903,-0.24782 3.5611503,-1.66096 4.9803003,-2.48586 1.58035,-0.90551 7.60593,-5.37303 9.29347,-6.065025 0.38587,-0.160351 5.0549,-1.531476 5.09434,-0.932948 0.0695,0.932948 -0.30784,1.137031 -0.18436,1.527183 0.22638,0.74602 1.44144,1.46546 2.02282,1.98509 1.50918,1.29224 3.21044,2.42841 4.27373,4.15625 1.49203,2.40183 1.55805,4.999171 1.98251,7.677111 0.99469,-0.11148 2.0091,-2.17545 2.55961,-2.99264 0.51278,-0.7726 2.38639,-4.071361 3.09725,-4.275441 0.67227,-0.20408 2.75511,0.95867 3.50284,1.18076 2.85973,0.84806 5.644,1.35398 8.560317,1.35398 3.50799,0.009 12.726,0.2581 19.55505,-4.80023 0.75545,-0.56766 2.55703,-2.7311 2.55703,-2.7311 0,0 -0.37644,-0.57709 -1.04785,-0.79061 0.89779,-0.58481 1.8659,-1.211632 1.94993,-1.92592 z"
            id="fish4" />
          <path
            id="fish5"
            d="m 127.65312,60.900973 c 0.0489,-0.44418 -0.2178,-0.896934 -1.01784,-1.415715 -0.72801,-0.47505 -1.4826,-0.932949 -2.2149,-1.401138 -1.6035,-1.02813 -3.29018,-1.969653 -4.89799,-3.079245 -4.67074,-3.24131 -10.22127,-4.404923 -15.76322,-5.150939 -2.27235,-0.286401 -4.812228,-0.168925 -6.721858,-1.574351 -1.48174,-1.081294 -4.04993,-4.828523 -6.86506,-6.456038 -0.4862,-0.290688 -2.77227,-1.444869 -2.77227,-1.444869 0,0 1.30939,3.550006 1.60951,4.264295 0.69542,1.644664 -0.38158,3.063809 -0.83262,4.642447 -0.29069,1.04185 2.13772,0.8129 2.26463,1.782721 0.18179,1.432007 -4.15197,1.936211 -6.59152,2.417263 -3.65634,0.715146 -7.91635,2.082842 -11.56925,0.884072 -4.3046,-1.383131 -7.37269,-4.12967 -10.46566,-7.235496 1.43801,6.725289 5.4382,10.602857 5.6157,11.422617 0.18607,0.905508 -0.45961,1.091583 -1.04099,1.682394 -1.28967,1.265654 -6.91566,7.731125 -6.93366,9.781382 1.61379,-0.247815 3.56115,-1.660957 4.9803,-2.485862 1.58035,-0.905509 7.60593,-5.373029 9.29347,-6.065023 0.38587,-0.160351 5.0549,-1.531476 5.09434,-0.932948 0.0695,0.932948 -0.30784,1.137031 -0.18436,1.527188 0.22638,0.746016 1.44144,1.46545 2.02282,1.985088 1.50918,1.292237 3.21044,2.42841 4.27373,4.156252 1.49203,2.401827 1.55805,4.999163 1.98251,7.677102 0.99469,-0.111473 2.0091,-2.17545 2.55961,-2.992638 0.51278,-0.772598 2.38639,-4.071359 3.09725,-4.275442 0.67227,-0.204082 2.75511,0.958673 3.50284,1.180763 2.85973,0.848057 5.643998,1.353976 8.560318,1.353976 3.50799,0.0094 12.726,0.258104 19.55506,-4.800226 0.75545,-0.567658 2.55703,-2.731104 2.55703,-2.731104 0,0 -0.37644,-0.57709 -1.04785,-0.790605 0.89779,-0.584808 1.8659,-1.211633 1.94993,-1.925921 z"
            style="fill:#183a70;fill-opacity:1"
            inkscape:connector-curvature="0"
            sodipodi:nodetypes="cccccccccccccccccccccccccccccccc" />
          <path
            d="m 68.19699,20.522295 c 0.0489,-0.44418 -0.2178,-0.896934 -1.01784,-1.415715 -0.72801,-0.47505 -1.4826,-0.932949 -2.2149,-1.401138 -1.6035,-1.02813 -3.29018,-1.969653 -4.89798,-3.079245 C 55.39553,11.384887 49.845,10.221274 44.30305,9.4752582 42.0307,9.1888572 39.49082,9.3063332 37.58119,7.900907 36.09945,6.819613 33.53126,3.072384 30.71613,1.444869 30.22993,1.154181 27.94386,0 27.94386,0 c 0,0 1.30939,3.550006 1.60951,4.264295 0.69542,1.644664 -0.38158,3.063809 -0.83262,4.642447 -0.29069,1.0418502 2.13772,0.8129002 2.26463,1.782721 0.18179,1.432007 -4.15197,1.936211 -6.59152,2.417263 -3.65634,0.715146 -7.91635,2.082842 -11.56925,0.884072 C 8.52001,12.607667 5.45192,9.8611282 2.35895,6.755302 3.79696,13.480591 7.79715,17.358159 7.97465,18.177919 8.16072,19.083427 7.51504,19.269502 6.93366,19.860313 5.64399,21.125967 0.018,27.591438 0,29.641695 1.61379,29.39388 3.56115,27.980738 4.9803,27.155833 c 1.58035,-0.905509 7.60593,-5.373029 9.29347,-6.065023 0.38587,-0.160351 5.0549,-1.531476 5.09434,-0.932948 0.0695,0.932948 -0.30784,1.137031 -0.18436,1.527188 0.22638,0.746016 1.44144,1.46545 2.02282,1.985088 1.50918,1.292237 3.21044,2.42841 4.27373,4.156252 1.49203,2.401827 1.55805,4.999163 1.98251,7.677102 0.99469,-0.111473 2.0091,-2.17545 2.55961,-2.992638 0.51278,-0.772598 2.38639,-4.071359 3.09725,-4.275442 0.67227,-0.204082 2.75511,0.958673 3.50284,1.180763 2.85973,0.848057 5.644,1.353976 8.56032,1.353976 3.50799,0.0094 12.726,0.258104 19.55505,-4.800226 0.75545,-0.567658 2.55703,-2.731104 2.55703,-2.731104 0,0 -0.37644,-0.57709 -1.04785,-0.790605 0.89779,-0.584808 1.8659,-1.211633 1.94993,-1.925921 z"
            id="fish1" />
        </svg>
      </div>
      <div class="row clearfix">
        <h1>Revenue and Attendance by State</h1>
        <div class="chart-wrapper">
          <highcharts id="state-overall-map" class="mapcontainer" :constructorType="'mapChart'" :options="revAttByState" ></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.</div>
        </div>
      </div>
    </figure>
    <article>
      <div class="row clearfix">
        <h1>Overall Results</h1>

        <div class="sixcol">
          <p>Results across jurisdictions were mixed, with some states recording their highest-ever revenue and attendance while in other states flattening after years of revenue and attendance growth.</p>
          <p><strong>New South Wales (NSW)</strong> achieved the highest market share in revenue (35.6%) and attendance (31.8%) amongst all states and territories in Australia, despite slight y-o-y declines in both revenue and attendance. NSW’s contribution to total revenue and attendance is greater than its share of the national population.</p>
          <ul>
            <li>In 2025, NSW generated $1.2b in total ticket revenue and 9.8m in total attendance. These results are the second-highest ever recorded in NSW, with 2024 being the highest.</li>
            <li>NSW spend per capita in 2025 was $138.20. This was the second-highest among all states and territories in Australia and higher than the national average.</li>
            <li><strong>Contemporary Music</strong> contributed the highest share of revenue (54.8%) and attendance (48.6%) among all live performance categories in NSW.</li>
            <li>NSW recorded the third-highest y-o-y decline in revenue (by 1.7% to $1.2b) and the third-highest y-o-y decline in attendance (by 4.2% to 9.8m) between 2024 and 2025.</li>
            <li>Overall revenue decline was driven by:
              <ul>
                <li>Y-o-y revenue declines in <strong>Special Events</strong> (47.7%), <strong>Comedy</strong> (24.3%), <strong>Theatre</strong> (20.1%), <strong>Ballet and Dance</strong> (16.1%), <strong>Musical Theatre</strong> (15.6%), <strong>Children’s/Family</strong> (10.1%), <strong>Contemporary Music</strong> (5.7%) and <strong>Festivals (Multi-Category)</strong> (5.6%). These declines were primarily due to the decline in attendance in 2025.</li>
                <li><strong>Festivals (Multi-Category)</strong> witnessed a decline in revenue despite an increase in attendance in 2025. This was primarily due to a fall in the average ticket price.</li>
              </ul>
            </li>
            <li>The y-o-y decline in revenue was partially offset by growth in the following categories:
              <ul>
                <li><strong>Circus and Physical Theatre</strong>* experienced significant y-o-y growth in revenue (142.8%) and attendance (66.1%) in 2025. However, Circus and Physical Theatre’s contribution to NSW’s overall revenue remained relatively low. Top events included Cirque Du Soleil: <em>Corteo</em>, <em>Now You See Me Live</em> and <em>Penn &amp; Teller</em>.</li>
                <li><strong>Classical Music</strong> recorded a 51.8% increase in revenue and a 15.4% increase in attendance. Top events included <em>Hans Zimmer Live</em>, <em>The Music of Joe Hisaishi</em> and performances by Andrea Bocelli.</li>
                <li><strong>Opera</strong> recorded a 50.6% increase in revenue and a 35.0% increase in attendance. Top events included <em>Carmen</em>, <em>Cinderella</em> and <em>La Traviata</em>.</li>
                <li><strong>Festivals (Contemporary Music)</strong> recorded a 30.6% increase in revenue and a 17.2% increase in attendance. Major festivals included Bluesfest, Knockout Outdoor 2025: Return of the Circuz and Hypersonic Festival.</li>
              </ul>
            </li>
            <li>Performances in <strong>regional NSW</strong> contributed 7.7% to revenue and 10.0% to attendance.</li>
          </ul>
          <p class="footnotes">*Cirque du Soleil’s <em>Luzia</em> was presented in NSW in 2024; however, data for this event were not included in the 2024 report. In 2025, data for Cirque du Soleil’s <em>Corteo</em> have been included, which appears to be a major contributor to the significant growth observed in Circus and Physical Theatre.</p>
          <hr class="divider"/>
          <p><strong>Victoria (VIC)</strong> achieved the second-highest market share in industry revenue (32.5%) and attendance (31.0%) amongst all states and territories in Australia, despite y-o-y declines in both revenue and attendance. VIC's contribution to total revenue and attendance is greater than its share of the national population.</p>
          <ul>
            <li>In 2025, VIC generated $1.1b in total ticket revenue and 9.5m in total attendance. This is the second-highest ever recorded revenue and attendance for the state, with 2024 being the highest.</li>
            <li>VIC spend per capita in 2025 was $152.82. This was the highest among all states and territories in Australia and higher than the national average.</li>
            <li><strong>Contemporary Music</strong> contributed the highest share to VIC’s overall revenue and attendance, at 54.9% and 46.5%, respectively.</li>
            <li>VIC recorded the second-highest y-o-y decline in revenue (3.8%) and the fourth-highest y-o-y decline in attendance (3.5%) between 2024 and 2025.</li>
            <li>The revenue decline was primarily driven by y-o-y declines in <strong>Special Events</strong> (36.2%), <strong>Comedy</strong> (18.9%), <strong>Musical Theatre</strong> (17.1%), <strong>Festivals (Multi-Category)</strong> (7.7%), <strong>Theatre</strong> (7.2%) and <strong>Contemporary Music</strong> (6.9%).</li>
            <li><strong>Special Events</strong>, <strong>Comedy</strong>, <strong>Musical Theatre</strong>, <strong>Theatre</strong> and <strong>Contemporary Music</strong> witnessed a decline in revenue, primarily due to the decline in attendance in 2025.</li>
            <li><strong>Festivals (Multi-Category)</strong> witnessed a decline in revenue despite an increase in attendance in 2025. This was primarily due to a fall in the average ticket price.</li>
            <li>The y-o-y decline in revenue was partially offset by growth in the following categories:
              <ul>
                <li><strong>Circus and Physical Theatre</strong>* experienced significant y-o-y growth in revenue (117.6%) and attendance (67.1%) in 2025. However, Circus and Physical Theatre’s contribution to VIC's overall revenue remained relatively low. Top events included <em>Cirque Du Soleil: Corteo</em>, <em>Penn &amp; Teller</em> and <em>Blanc de Blanc Encore</em>.</li>
                <li><strong>Opera</strong> recorded a 63.6% increase in revenue and a 29.8% increase in attendance. Top events included <em>Carmen</em>, <em>The Barber of Seville</em> and <em>Orpheus &amp; Eurydice</em>.</li>
                <li><strong>Festivals (Contemporary Music)</strong> recorded a 35.7% increase in revenue and a 13.8% increase in attendance. Major festivals included Beyond The Valley, Spilt Milk and Laneway Festival.</li>
                <li>Several other categories also recorded y-o-y increases in total ticket revenue, including <strong>Classical Music</strong> (25.5%) and <strong>Ballet and Dance</strong> (10.8%), primarily due to an increase in attendance. <strong>Children's/Family</strong> recorded a 4.1% increase in revenue despite a 2.7% decline in attendance.</li>
              </ul>
            </li>
            <li>Performances in <strong>regional VIC</strong> accounted for 8.7% of the state’s total revenue and 6.8% of its total attendance.</li>
          </ul>
          <p class="footnotes">*Cirque du Soleil’s <em>Luzia</em> was presented in NSW in 2024; however, data for this event were not included in the 2024 report. In 2025, data for Cirque du Soleil’s <em>Corteo</em> have been included, which appears to be a major contributor to the significant growth observed in Circus and Physical Theatre.</p>
          <hr class="divider"/>
          <p><strong>Queensland (QLD)</strong> accounted for the third-largest share of total revenue (15.1%) and attendance (15.2%) among the states and territories, despite experiencing y-o-y declines in revenue and attendance in 2025.</p>
          <ul>
            <li>QLD generated $506.4m in total ticket revenue and recorded close to 4.7m in attendance. This is the third-highest recorded revenue and attendance (behind 2024 and 2023) for the state.</li>
            <li>QLD spend per capita in 2025 was $88.65, the fifth-highest among all states and territories in Australia, but lower than the national average.</li>
            <li><strong>Contemporary Music</strong> contributed the highest share of QLD’s total revenue (54.1%) and total attendance (47.8%) in 2025.</li>
            <li>In 2025, QLD experienced a decline in revenue by 1.5% and in attendance by 5.5%. These results were primarily driven by the declines in revenue in <strong>Opera</strong> (84.2%), <strong>Musical Theatre</strong> (30.7%), <strong>Children's/Family</strong> (26.9%), <strong>Comedy</strong> (26.3%) and <strong>Festivals (Contemporary Music)</strong> (13.3%).</li>
            <li><strong>Opera</strong>, <strong>Musical Theatre</strong>, <strong>Children's/Family</strong>, <strong>Festivals (Contemporary Music)</strong> and <strong>Comedy</strong> witnessed a decline in revenue, primarily due to the decline in attendance in 2025.</li>
            <li>The y-o-y decline in revenue was partially offset by growth in the following categories:
              <ul>
                <li><strong>Circus and Physical Theatre</strong>* experienced significant y-o-y growth in revenue (516.9%) and attendance (367.3%) in 2025. However, <strong>Circus and Physical Theatre’s</strong> contribution to QLD’s overall revenue remained relatively low. Top events included <em>Cirque Du Soleil: Corteo</em>, <em>Blanc de Blanc Encore</em> and <em>Cirque Alice</em>.</li>
                <li><strong>Theatre</strong> recorded a 115.9% increase in revenue and an 83.3% increase in attendance. Top events included <em>The Dictionary of Lost Words</em>, <em>The 39 Steps</em> and <em>Julia</em>.</li>
                <li><strong>Classical Music</strong> recorded a 48.3% increase in revenue and a 16.1% increase in attendance. Top events included <em>Hans Zimmer Live,</em> <em>The Man From Snowy River in Concert</em> and <em>Top Gun: Maverick in Concert</em>.</li>
                <li><strong>Festivals (Multi-Category)</strong> recorded an 18.8% increase in revenue, despite a 19.2% decline in attendance. Major festivals included Woodford Folk Festival, Oktoberfest in the Gardens and Brisbane Festival.</li>
                <li><strong>Special Events</strong> recorded a 17.5% increase in revenue and a 78.8% increase in attendance. Top events included <em>Rupaul's Drag Race</em>, <em>The Christmas Spectacular</em> and <em>RocKwiz Live!</em>.</li>
                <li><strong>Ballet and Dance</strong> recorded a 12.9% increase in revenue and a 7.6% increase in attendance.</li>
                <li><strong>Contemporary Music</strong> recorded a 2.9% increase in revenue, despite a 4.5% decline in attendance.</li>
              </ul>
            </li>
            <li>Performances in <strong>regional QLD</strong> contributed 19.5% to revenue and 23.7% to attendance.</li>
          </ul>
          <p class="footnotes">*Cirque du Soleil’s <em>Luzia</em> was presented in NSW in 2024; however, data for this event were not included in the 2024 report. In 2025, data for Cirque du Soleil’s <em>Corteo</em> have been included, which appears to be a major contributor to the significant growth observed in Circus and Physical Theatre.</p>
        </div>
        <div class="sixcol last">
          <p><strong>Western Australia (WA)</strong> recorded the second-highest y-o-y growth in revenue (19.1%) and the third-highest y-o-y growth in attendance (4.3%) among all states and territories in Australia.</p>
          <ul>
            <li>In 2025, WA generated $297.2m in total ticket revenue and 3.0m in total attendance. This is the second-highest ever recorded revenue and attendance for the state (with 2023 being the highest).</li>
            <li>WA accounted for 8.9% of the industry’s total revenue share and 9.9% of the industry’s total attendance share.</li>
            <li>WA spend per capita in 2025 was $96.59, the fourth-highest among all states and territories in Australia, but lower than the national average.</li>
            <li><strong>Contemporary Music</strong> contributed the highest share of WA’s total revenue (52.7%) and total attendance (43.3%).</li>
            <li>The y-o-y increase in revenue and attendance was driven primarily by growth in the following categories:
              <ul>
                <li><strong>Circus and Physical Theatre*</strong> recorded significant growth in revenue of 251.9%. This was driven by an increase in attendance of 76.7% and an increase in the average ticket price. Top events included <em>Cirque Du Soleil: Corteo</em>, <em>La Clique</em>, <em>Mystique</em> and <em>Circus Rio Carnival</em>.</li>
                <li><strong>Opera</strong> recorded a 63.8% increase in revenue and a 75.9% increase in attendance. Top events included <em>Madama Butterfly</em>, <em>The Pirates of Penzance</em> and <em>Il Trovatore</em>.</li>
                <li><strong>Contemporary Music</strong> recorded a 31.4% increase in revenue and an 11.9% increase in attendance. Top events included performances by AC/DC, Metallica and Drake.</li>
                <li><strong>Musical Theatre</strong> recorded a 24.9% increase in revenue and a 15.5% increase in attendance. Top events included <em>Beauty and the Beast</em>, <em>Wicked</em> and <em>Cats</em>.</li>
                <li><strong>Festivals (Contemporary Music)</strong> recorded a 15.9% increase in revenue and a 14.7% increase in attendance. Major festivals included Spilt Milk, Wildlands and Strummingbird.</li>
                <li><strong>Festivals (Multi-Category)</strong> recorded a 9.4% increase in revenue, despite a 7.7% decline in attendance.</li>
                <li><strong>Theatre</strong> recorded a 6.6% increase in revenue and a 2.1% increase in attendance.</li>
                <li><strong>Children’s/Family</strong> recorded a 4.8% increase in revenue and a 1.7% increase in attendance.</li>
                <li>The growth in revenue was slightly offset by y-o-y declines in revenue across several categories, including <strong>Special Events</strong> (43.1%), <strong>Classical Music</strong> (33.7%), <strong>Ballet and Dance</strong> (31.0%) and <strong>Comedy</strong> (24.3%).</li>
              </ul>
            </li>
            <li>Performances in <strong>regional WA</strong> contributed 10.2% to revenue and 12.3% to attendance.</li>
          </ul>
          <p class="footnotes">*Cirque du Soleil’s <em>Luzia</em> was presented in NSW in 2024; however, data for this event were not included in the 2024 report. In 2025, data for Cirque du Soleil’s <em>Corteo</em> have been included, which appears to be a major contributor to the significant growth observed in Circus and Physical Theatre.</p>
          <hr class="divider"/>
          <p><strong>South Australia (SA)</strong> accounted for 5.7% of the industry’s total revenue share and 8.6% of the industry’s total attendance share in 2025. SA recorded the third-highest y-o-y growth in revenue and the fourth-highest y-o-y growth in attendance among all states and territories in Australia.</p>
          <ul>
            <li>In 2025, SA generated $189.7m in total ticket revenue and recorded 2.6m in attendance, reflecting an 8.1% y-o-y increase in revenue and a 4.2% y-o-y increase in attendance. This is the highest ever recorded revenue and attendance for the state.</li>
            <li>SA spend per capita in 2025 was $99.29, the third-highest among all states and territories in Australia, but lower than the national average.</li>
            <li><strong>Contemporary Music</strong> contributed the highest share of SA's overall revenue (47.5%), while <strong>Festivals (Multi-Category)</strong> accounted for the highest share of attendance (43.9%).</li>
            <li>The y-o-y increase in revenue and attendance was driven primarily by growth in the following categories:
              <ul>
                <li><strong>Circus and Physical Theatre</strong>* recorded significant growth in revenue of 299.5%. This was driven by an increase in attendance of 108.6%. Top events included <em>Cirque Du Soleil: Corteo</em>, <em>Silvers Circus</em> and <em>Cosentino – Decennium</em>.</li>
                <li><strong>Theatre</strong> recorded a 47.7% increase in revenue and a 29.5% increase in attendance. Top events included <em>And Then There Were None</em>, <em>The Dictionary of Lost Words</em> and <em>Housework</em>.</li>
                <li><strong>Contemporary Music</strong> recorded a 35.3% increase in revenue and a 15.4% increase in attendance. Top events included performances by Metallica, Katy Perry and AC/DC.</li>
                <li><strong>Ballet and Dance</strong> recorded a 35.1% increase in revenue and an 86.0% increase in attendance. Top events included <em>The Sleeping Beauty</em>, <em>The Nutcracker</em> and <em>Romeo and Juliet</em>.</li>
                <li><strong>Festivals (Multi-Category)</strong> recorded a marginal 1.8% increase in revenue, driven by a 5.3% increase in attendance. Major festivals included Adelaide Fringe, Adelaide Festival and Adelaide Beer &amp; BBQ Festival.</li>
              </ul>
            </li>
            <li>The growth in revenue was partially offset by y-o-y declines in revenue across several categories, including <strong>Special Events</strong> (43.2%), <strong>Comedy</strong> (42.7%), <strong>Children’s/Family</strong> (35.1%), <strong>Musical Theatre</strong> (20.9%), <strong>Opera</strong> (18.5%), <strong>Festivals (Contemporary Music)</strong> (11.1%) and <strong>Classical Music</strong> (7.0%), primarily due to the decline in attendance.</li>
            <li>Performances in <strong>regional SA</strong> contributed 2.3% to revenue and 2.8% to attendance.</li>
          </ul>
          <p class="footnotes">*Cirque du Soleil’s <em>Luzia</em> was presented in NSW in 2024; however, data for this event were not included in the 2024 report. In 2025, data for Cirque du Soleil’s <em>Corteo</em> have been included, which appears to be a major contributor to the significant growth observed in Circus and Physical Theatre.</p>
          <hr class="divider"/>
          <p><strong>Tasmania (TAS)</strong> recorded a 5.0% y-o-y decline in revenue (to $28.8m) and the highest y-o-y growth in attendance among all states and territories, increasing by 26.7% to 0.5m in 2025.</p>
          <ul>
            <li>TAS spend per capita in 2025 was $49.77</li>
            <li>The decline in revenue was primarily driven by y-o-y declines in <strong>Ballet and Dance</strong>, <strong>Classical Music</strong>, <strong>Festivals (Contemporary Music)</strong>, <strong>Musical Theatre</strong>, <strong>Contemporary Music</strong>, <strong>Special Events</strong>, <strong>Theatre</strong>, <strong>Circus and Physical Theatre</strong> and <strong>Comedy</strong>.</li>
            <li>The growth in attendance was primarily driven by y-o-y growth in <strong>Festivals (Multi-Category)</strong>, <strong>Children’s/Family</strong> and <strong>Opera</strong>.</li>
            <li>Top events included Dark Mofo, Party in the Paddock Festival and Great Escape NYE Festival.</li>
            <li>Performances in <strong>regional TAS</strong> contributed $17.5m (60.6%) to revenue and 242k (47.5%) to attendance.</li>
          </ul>
          <hr class="divider"/>
          <p><strong>Australian Capital Territory (ACT)</strong> recorded the highest y-o-y increase in revenue among all states and territories, increasing by 26.3% to $38.1m, and the second-highest y-o-y increase in attendance, increasing by 8.3% to 0.4m.</p>
          <ul>
            <li>ACT spend per capita of $78.30.</li>
            <li>The growth in revenue and attendance was primarily driven by y-o-y growth in <strong>Festivals (Contemporary Music)</strong>, <strong>Festivals (Multi-Category)</strong>, <strong>Ballet and Dance</strong>, <strong>Children’s/Family</strong>, <strong>Classical Music</strong> and <strong>Opera</strong>.</li>
            <li>Top events included Spilt Milk Festival, <em>Bluey's Big Play</em> and performances by Ricky Martin.</li>
            <li>Performances in <strong>regional ACT</strong> contributed $15.3m (40.2%) to revenue and 102k (24.8%) to attendance.</li>
          </ul>
          <hr class="divider"/>
          <p><strong>Northern Territory (NT)</strong> recorded a 2.1% y-o-y increase in revenue to $8.6m and the highest y-o-y decline in attendance among all states and territories, decreasing by 27.8% to 0.2m in 2025.</p>
          <ul>
            <li>NT had the lowest per capita spend of $32.08 in 2025.</li>
            <li>The growth in revenue was primarily driven by y-o-y growth in <strong>Musical Theatre</strong>, <strong>Children’s/Family</strong>, <strong>Classical Music</strong>, <strong>Contemporary Music</strong>, and <strong>Festivals (Multi-Category)</strong>.</li>
            <li>The decline in attendance was primarily driven by y-o-y declines in <strong>Special Events</strong>, <strong>Theatre</strong>, <strong>Circus and Physical Theatre</strong>, <strong>Ballet and Dance</strong>, <strong>Classical Music</strong>, <strong>Festivals (Multi-Category)</strong> and <strong>Festivals (Contemporary Music)</strong>.</li>
            <li>Top events included Darwin Festival, BASSINTHEGRASS Music Festival and The Top End Gin Festival.</li>
            <li>Performances in <strong>regional NT</strong> contributed $1.9m (22.5%) to revenue and 29k (18.4%) to attendance.</li>
          </ul>
        </div>
      </div>
    </article>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      activeYear: 2025,
      year: [2025],
      reports: [
        {
          year: 2025,
          revenue: [
            {
              'hc-key': 'au-ns',
              label: 'NSW',
              z: 35.6,
              value: '35.6',
              labelsize: 1.75,
              absolute: '$1.19b'
            }, {
              'hc-key': 'au-vi',
              label: 'VIC',
              z: 32.5,
              value: '32.5',
              labelsize: 1.7,
              absolute: '$1.09b'
            }, {
              'hc-key': 'au-ql',
              label: 'QLD',
              z: 15.1,
              value: '15.1',
              labelsize: 1.4,
              absolute: '$506.38m'
            }, {
              'hc-key': 'au-wa',
              label: 'WA',
              z: 8.9,
              value: '8.9',
              labelsize: 1.25,
              absolute: '$297.17m'
            }, {
              'hc-key': 'au-sa',
              label: 'SA',
              z: 5.7,
              value: '5.7',
              labelsize: 1.25,
              absolute: '$189.70m'
            }, {
              'hc-key': 'au-ct',
              label: 'ACT',
              z: 1.1,
              value: '1.1',
              labelsize: 1.25,
              absolute: '$38.15m'
            }, {
              'hc-key': 'au-ts',
              label: 'TAS',
              z: 0.9,
              value: '0.9',
              labelsize: 1.25,
              absolute: '$28.82m'
            }, {
              'hc-key': 'au-nt',
              label: 'NT',
              z: 0.3,
              value: '0.3',
              labelsize: 1.25,
              absolute: '$8.58m'
            }
          ],
          attendance: [
            {
              'hc-key': 'au-ns',
              label: 'NSW',
              z: 31.8,
              value: '31.8',
              labelsize: 1.25,
              absolute: '9.77m'
            }, {
              'hc-key': 'au-vi',
              label: 'VIC',
              z: 31.0,
              value: '31.0',
              labelsize: 1.25,
              absolute: '9.53m'
            }, {
              'hc-key': 'au-ql',
              label: 'QLD',
              z: 15.2,
              value: '15.2',
              labelsize: 1.25,
              absolute: '4.67m'
            }, {
              'hc-key': 'au-wa',
              label: 'WA',
              z: 9.9,
              value: '9.9',
              labelsize: 1.25,
              absolute: '3.02m'
            }, {
              'hc-key': 'au-sa',
              label: 'SA',
              z: 8.6,
              value: '8.6',
              labelsize: 1.25,
              absolute: '2.64m'
            }, {
              'hc-key': 'au-ct',
              label: 'ACT',
              z: 1.3,
              value: '1.3',
              labelsize: 1.25,
              absolute: '410,421'
            }, {
              'hc-key': 'au-ts',
              label: 'TAS',
              z: 1.7,
              value: '1.7',
              labelsize: 1.25,
              absolute: '509,374'
            }, {
              'hc-key': 'au-nt',
              label: 'NT',
              z: 0.5,
              value: '0.5',
              labelsize: 1.25,
              absolute: '155,248'
            }
          ]
        },
      ],
    }
  },
  computed: {
    revAttByState () {
      const self = this

      for (let i = 0; i < self.reports.length; i++) {
        const report = self.reports[i]
        if (report.year === self.activeYear) {
          return {
            chart: {
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            mapNavigation: {
              enabled: false
            },
            legend: {
              enabled: false
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              }
            },
            tooltip: {
              formatter () {
                return this.key + '<br />' + this.series.name + ': ' + this.point.value + '% (' + this.point.absolute + ')'
              }
            },
            series: [{
              color: '#e2c655',
              borderWidth: '0',
              enableMouseTracking: false,
              data: [{
                'hc-key': 'au-ns'
              }, {
                'hc-key': 'au-vi'
              }, {
                'hc-key': 'au-ql'
              }, {
                'hc-key': 'au-wa'
              }, {
                'hc-key': 'au-sa'
              }, {
                'hc-key': 'au-ct'
              }, {
                'hc-key': 'au-ts'
              }, {
                'hc-key': 'au-nt'
              }],
              mapData: {
                "title": "Australia",
                "version": "1.0.2",
                "type": "FeatureCollection",
                "copyright": "Copyright (c) 2014 Highsoft AS, Based on data from Natural Earth http://www.naturalearthdata.com",
                "copyrightShort": "Natural Earth",
                "copyrightUrl": "http://www.naturalearthdata.com",
                "crs": {
                  "type": "name",
                  "properties": {
                    "name": "urn:ogc:def:crs:EPSG:3112"
                  }
                },
                "features": [{
                  "type": "Feature",
                  "id": "AU.NT",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.50,
                    "hc-middle-y": 0.57,
                    "hc-key": "au-nt",
                    "hc-a2": "NT",
                    "labelrank": "2",
                    "hasc": "AU.NT",
                    "alt-name": null,
                    "woe-id": "2344701",
                    "subregion": null,
                    "fips": "AS03",
                    "postal-code": "NT",
                    "name": "Northern Territory",
                    "country": "Australia",
                    "type-en": "Territory",
                    "region": null,
                    "longitude": "133.78",
                    "woe-name": "Northern Territory",
                    "latitude": "-20.1026",
                    "woe-label": "Northern Territory, AU, Australia",
                    "type": "Territory"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[932, 1724], [936, 1727], [944, 1721], [940, 1711], [951, 1704], [948, 1701], [928, 1706], [928, 1723], [932, 1724]]], [[[663, 1826], [666, 1816], [674, 1812], [649, 1810], [655, 1818], [655, 1825], [661, 1833], [663, 1826]]], [[[668, 1835], [678, 1830], [691, 1832], [700, 1839], [709, 1837], [714, 1827], [704, 1816], [690, 1806], [668, 1818], [662, 1837], [668, 1835]]], [[[992, 1601], [992, 1601], [992, 1600], [979, 1190], [627, 1188], [608, 1673], [608, 1673], [620, 1663], [618, 1675], [629, 1671], [637, 1662], [630, 1677], [643, 1675], [633, 1687], [623, 1694], [630, 1709], [638, 1712], [644, 1738], [655, 1737], [660, 1745], [654, 1751], [654, 1760], [662, 1762], [664, 1774], [672, 1775], [675, 1783], [694, 1787], [692, 1798], [713, 1790], [731, 1794], [737, 1790], [765, 1798], [762, 1820], [751, 1830], [739, 1825], [731, 1834], [724, 1835], [734, 1843], [744, 1831], [743, 1843], [750, 1844], [759, 1835], [755, 1848], [759, 1850], [764, 1826], [773, 1835], [787, 1817], [805, 1814], [814, 1818], [820, 1809], [826, 1811], [842, 1802], [857, 1807], [870, 1793], [883, 1801], [893, 1800], [893, 1806], [910, 1811], [895, 1797], [899, 1790], [906, 1798], [913, 1794], [912, 1784], [922, 1784], [927, 1792], [916, 1801], [931, 1806], [941, 1791], [946, 1797], [951, 1788], [932, 1766], [938, 1761], [931, 1749], [926, 1756], [917, 1748], [905, 1745], [905, 1727], [912, 1731], [920, 1722], [910, 1723], [905, 1707], [899, 1704], [882, 1684], [886, 1674], [919, 1652], [929, 1640], [934, 1648], [938, 1630], [950, 1632], [966, 1620], [982, 1614], [992, 1601]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.WA",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.57,
                    "hc-middle-y": 0.54,
                    "hc-key": "au-wa",
                    "hc-a2": "WA",
                    "labelrank": "2",
                    "hasc": "AU.WA",
                    "alt-name": null,
                    "woe-id": "2344706",
                    "subregion": null,
                    "fips": "AS08",
                    "postal-code": "WA",
                    "name": "Western Australia",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "121.646",
                    "woe-name": "Western Australia",
                    "latitude": "-25.8483",
                    "woe-label": "Western Australia, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[0, 1146], [14, 1124], [7, 1127], [0, 1139], [0, 1146]]], [[[608, 1673], [608, 1673], [627, 1188], [637, 958], [637, 942], [602, 924], [575, 914], [553, 911], [534, 913], [523, 908], [511, 898], [492, 889], [482, 881], [469, 877], [461, 869], [457, 850], [443, 832], [429, 828], [426, 834], [399, 829], [390, 825], [387, 832], [380, 829], [370, 831], [335, 824], [330, 820], [315, 820], [301, 809], [291, 791], [276, 793], [274, 786], [264, 780], [262, 771], [238, 762], [236, 757], [226, 761], [200, 756], [176, 762], [160, 777], [149, 782], [142, 778], [135, 790], [132, 814], [143, 810], [148, 813], [155, 828], [148, 854], [152, 860], [149, 887], [145, 898], [121, 931], [109, 956], [105, 987], [97, 1003], [85, 1015], [82, 1026], [65, 1041], [61, 1059], [54, 1074], [33, 1099], [20, 1109], [22, 1119], [32, 1103], [41, 1104], [42, 1115], [34, 1119], [20, 1138], [24, 1144], [34, 1133], [38, 1120], [41, 1131], [45, 1116], [51, 1112], [53, 1139], [49, 1140], [27, 1166], [20, 1182], [12, 1189], [8, 1210], [12, 1229], [17, 1235], [17, 1255], [7, 1274], [16, 1307], [22, 1311], [21, 1294], [28, 1280], [35, 1283], [42, 1312], [72, 1331], [99, 1365], [107, 1367], [121, 1381], [125, 1374], [135, 1380], [144, 1376], [159, 1381], [174, 1396], [201, 1404], [206, 1413], [215, 1418], [230, 1415], [240, 1421], [257, 1426], [285, 1441], [294, 1449], [306, 1467], [316, 1495], [320, 1495], [335, 1511], [336, 1517], [328, 1517], [325, 1549], [340, 1571], [351, 1572], [348, 1580], [353, 1589], [377, 1550], [384, 1543], [387, 1558], [384, 1566], [396, 1557], [387, 1578], [375, 1587], [387, 1591], [379, 1606], [389, 1604], [387, 1598], [399, 1594], [395, 1601], [414, 1594], [432, 1596], [416, 1598], [423, 1615], [415, 1617], [413, 1633], [423, 1634], [437, 1659], [452, 1652], [456, 1658], [442, 1669], [441, 1681], [446, 1676], [461, 1680], [461, 1694], [465, 1682], [470, 1685], [475, 1676], [480, 1682], [483, 1701], [487, 1696], [496, 1707], [504, 1696], [509, 1716], [518, 1720], [526, 1709], [535, 1712], [549, 1701], [559, 1689], [574, 1679], [569, 1660], [582, 1675], [588, 1677], [608, 1673]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.SA",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.54,
                    "hc-middle-y": 0.36,
                    "hc-key": "au-sa",
                    "hc-a2": "SA",
                    "labelrank": "2",
                    "hasc": "AU.SA",
                    "alt-name": null,
                    "woe-id": "2344703",
                    "subregion": null,
                    "fips": "AS05",
                    "postal-code": "SA",
                    "name": "South Australia",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "135.783",
                    "woe-name": "South Australia",
                    "latitude": "-29.6504",
                    "woe-label": "South Australia, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[953, 774], [951, 768], [968, 766], [967, 759], [957, 762], [946, 753], [937, 757], [920, 754], [913, 761], [915, 767], [943, 775], [953, 774]]], [[[637, 942], [637, 958], [627, 1188], [979, 1190], [1096, 1185], [1089, 1055], [1077, 838], [1076, 839], [1066, 661], [1057, 661], [1045, 670], [1042, 679], [1033, 688], [1025, 701], [1023, 712], [1030, 719], [1030, 726], [1021, 750], [1003, 772], [1007, 776], [1010, 767], [1015, 777], [1012, 783], [1001, 780], [1002, 774], [993, 775], [985, 771], [973, 770], [970, 775], [982, 784], [986, 810], [977, 824], [971, 837], [955, 792], [945, 795], [937, 790], [925, 790], [932, 805], [947, 804], [950, 817], [948, 837], [954, 849], [967, 864], [962, 876], [970, 880], [964, 906], [961, 887], [949, 881], [940, 859], [918, 849], [909, 841], [904, 831], [893, 822], [891, 811], [895, 802], [881, 807], [865, 823], [874, 817], [872, 833], [866, 850], [854, 861], [853, 874], [847, 879], [833, 882], [826, 901], [834, 903], [828, 913], [817, 909], [821, 916], [810, 928], [801, 923], [791, 924], [778, 934], [758, 931], [731, 949], [718, 954], [705, 948], [680, 949], [637, 942]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.ACT",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.37,
                    "hc-middle-y": 0.48,
                    "hc-key": "au-ct",
                    "hc-a2": "CT",
                    "labelrank": "9",
                    "hasc": "AU.CT",
                    "alt-name": null,
                    "woe-id": "1100968",
                    "subregion": null,
                    "fips": "AS01",
                    "postal-code": "CT",
                    "name": "Australian Capital Territory",
                    "country": "Australia",
                    "type-en": "Territory",
                    "region": null,
                    "longitude": "148.983",
                    "woe-name": "Canberra",
                    "latitude": "-35.4618",
                    "woe-label": null,
                    "type": "Territory"
                  },
                  "geometry": {
                    "type": "Polygon",
                    "coordinates": [[[1373, 753], [1366, 752], [1361, 743], [1361, 733], [1355, 731], [1350, 740], [1354, 757], [1364, 763], [1373, 753]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.QLD",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.44,
                    "hc-middle-y": 0.66,
                    "hc-key": "au-ql",
                    "hc-a2": "QL",
                    "labelrank": "2",
                    "hasc": "AU.QL",
                    "alt-name": null,
                    "woe-id": "2344702",
                    "subregion": null,
                    "fips": "AS04",
                    "postal-code": "QL",
                    "name": "Queensland",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "144.778",
                    "woe-name": "Queensland",
                    "latitude": "-23.1364",
                    "woe-label": "Queensland, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[1582, 1189], [1584, 1176], [1566, 1145], [1564, 1156], [1570, 1171], [1579, 1180], [1576, 1186], [1582, 1189]]], [[[1502, 1257], [1508, 1252], [1507, 1242], [1499, 1255], [1502, 1257]]], [[[1552, 1035], [1538, 1037], [1529, 1043], [1507, 1034], [1507, 1019], [1489, 1018], [1480, 1010], [1479, 1021], [1462, 1036], [1449, 1037], [1444, 1042], [1433, 1041], [1413, 1044], [1391, 1029], [1089, 1055], [1096, 1185], [979, 1190], [992, 1600], [992, 1601], [1000, 1594], [1020, 1590], [1036, 1583], [1045, 1564], [1075, 1547], [1096, 1549], [1110, 1556], [1122, 1584], [1127, 1588], [1139, 1615], [1137, 1621], [1143, 1641], [1152, 1661], [1147, 1685], [1151, 1703], [1147, 1708], [1149, 1725], [1158, 1739], [1154, 1751], [1165, 1765], [1155, 1771], [1165, 1792], [1171, 1789], [1182, 1823], [1185, 1841], [1198, 1850], [1205, 1848], [1214, 1818], [1213, 1798], [1227, 1791], [1221, 1776], [1235, 1762], [1231, 1751], [1237, 1748], [1239, 1721], [1236, 1711], [1241, 1699], [1244, 1682], [1251, 1676], [1261, 1682], [1264, 1692], [1267, 1684], [1277, 1689], [1282, 1672], [1291, 1669], [1296, 1659], [1309, 1652], [1304, 1646], [1304, 1626], [1310, 1603], [1306, 1586], [1320, 1565], [1327, 1565], [1323, 1558], [1332, 1531], [1324, 1504], [1336, 1504], [1337, 1497], [1332, 1477], [1338, 1468], [1365, 1450], [1378, 1451], [1386, 1429], [1389, 1435], [1396, 1425], [1410, 1421], [1414, 1411], [1421, 1416], [1422, 1408], [1434, 1404], [1422, 1393], [1429, 1380], [1443, 1368], [1449, 1339], [1447, 1336], [1452, 1316], [1467, 1296], [1464, 1312], [1470, 1318], [1475, 1306], [1490, 1295], [1488, 1312], [1496, 1300], [1498, 1290], [1493, 1271], [1493, 1260], [1515, 1230], [1528, 1228], [1539, 1200], [1548, 1193], [1555, 1171], [1564, 1167], [1562, 1147], [1571, 1138], [1564, 1124], [1564, 1090], [1557, 1085], [1566, 1060], [1571, 1074], [1571, 1076], [1571, 1076], [1571, 1076], [1575, 1073], [1567, 1051], [1568, 1041], [1552, 1035]]], [[[1043, 1594], [1047, 1602], [1060, 1605], [1053, 1593], [1043, 1594], [1043, 1594], [1043, 1594]]], [[[1571, 1077], [1571, 1076], [1571, 1076], [1571, 1076], [1570, 1076], [1571, 1077], [1571, 1077]]], [[[1571, 1077], [1570, 1089], [1573, 1090], [1571, 1077], [1571, 1077]]], [[[1043, 1594], [1041, 1587], [1042, 1594], [1043, 1594], [1043, 1594], [1043, 1594]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.TAS",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.61,
                    "hc-middle-y": 0.65,
                    "hc-key": "au-ts",
                    "hc-a2": "TS",
                    "labelrank": "2",
                    "hasc": "AU.TS",
                    "alt-name": null,
                    "woe-id": "2344704",
                    "subregion": null,
                    "fips": "AS06",
                    "postal-code": "TS",
                    "name": "Tasmania",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "146.603",
                    "woe-name": null,
                    "latitude": "-42.1383",
                    "woe-label": null,
                    "type": "State"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[1307, 532], [1300, 538], [1311, 540], [1315, 534], [1307, 532]]], [[[1301, 568], [1311, 555], [1310, 543], [1304, 542], [1293, 561], [1301, 568]]], [[[1167, 565], [1162, 562], [1161, 581], [1169, 584], [1169, 568], [1167, 565]]], [[[1188, 539], [1187, 536], [1200, 528], [1219, 521], [1222, 517], [1242, 509], [1263, 515], [1277, 512], [1283, 519], [1291, 516], [1297, 522], [1307, 509], [1301, 474], [1303, 459], [1296, 463], [1290, 452], [1286, 437], [1284, 411], [1278, 411], [1274, 421], [1281, 419], [1281, 426], [1271, 429], [1272, 424], [1261, 419], [1263, 406], [1255, 411], [1245, 396], [1236, 402], [1225, 405], [1219, 403], [1217, 419], [1213, 415], [1210, 427], [1204, 431], [1198, 448], [1197, 466], [1204, 458], [1198, 477], [1190, 489], [1182, 522], [1188, 539]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.NSW",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.44,
                    "hc-middle-y": 0.39,
                    "hc-key": "au-ns",
                    "hc-a2": "NS",
                    "labelrank": "2",
                    "hasc": "AU.NS",
                    "alt-name": null,
                    "woe-id": "2344700",
                    "subregion": null,
                    "fips": "AS02",
                    "postal-code": "NS",
                    "name": "New South Wales",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "146.781",
                    "woe-name": "New South Wales",
                    "latitude": "-32.4751",
                    "woe-label": "New South Wales, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "Polygon",
                    "coordinates": [[[1418, 754], [1398, 726], [1395, 707], [1383, 682], [1386, 666], [1382, 656], [1324, 694], [1325, 701], [1320, 728], [1311, 734], [1300, 734], [1297, 729], [1279, 730], [1272, 736], [1263, 734], [1241, 740], [1235, 746], [1215, 747], [1214, 737], [1205, 736], [1194, 746], [1191, 754], [1160, 781], [1160, 798], [1138, 808], [1131, 801], [1126, 812], [1127, 820], [1121, 827], [1104, 832], [1097, 828], [1077, 838], [1089, 1055], [1391, 1029], [1413, 1044], [1433, 1041], [1444, 1042], [1449, 1037], [1462, 1036], [1479, 1021], [1480, 1010], [1489, 1018], [1507, 1019], [1507, 1034], [1529, 1043], [1538, 1037], [1552, 1035], [1568, 1041], [1570, 1036], [1567, 1010], [1554, 992], [1551, 976], [1531, 934], [1534, 926], [1525, 902], [1505, 875], [1504, 863], [1486, 850], [1476, 848], [1453, 819], [1449, 804], [1434, 790], [1428, 771], [1427, 761], [1421, 757], [1419, 756], [1418, 754]], [[1373, 753], [1364, 763], [1354, 757], [1350, 740], [1355, 731], [1361, 733], [1361, 743], [1366, 752], [1373, 753]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.VIC",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.38,
                    "hc-middle-y": 0.62,
                    "hc-key": "au-vi",
                    "hc-a2": "VI",
                    "labelrank": "2",
                    "hasc": "AU.VI",
                    "alt-name": null,
                    "woe-id": "2344705",
                    "subregion": null,
                    "fips": "AS07",
                    "postal-code": "VI",
                    "name": "Victoria",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "144.75",
                    "woe-name": "Victoria",
                    "latitude": "-37.0082",
                    "woe-label": "Victoria, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "Polygon",
                    "coordinates": [[[1066, 661], [1076, 839], [1077, 838], [1097, 828], [1104, 832], [1121, 827], [1127, 820], [1126, 812], [1131, 801], [1138, 808], [1160, 798], [1160, 781], [1191, 754], [1194, 746], [1205, 736], [1214, 737], [1215, 747], [1235, 746], [1241, 740], [1263, 734], [1272, 736], [1279, 730], [1297, 729], [1300, 734], [1311, 734], [1320, 728], [1325, 701], [1324, 694], [1382, 656], [1375, 655], [1363, 646], [1322, 649], [1308, 647], [1296, 641], [1269, 619], [1245, 616], [1248, 609], [1255, 614], [1251, 598], [1241, 614], [1235, 610], [1232, 622], [1209, 629], [1215, 635], [1216, 642], [1203, 631], [1198, 637], [1205, 638], [1210, 646], [1206, 658], [1201, 658], [1190, 650], [1197, 647], [1194, 642], [1185, 642], [1172, 635], [1164, 626], [1153, 619], [1137, 631], [1129, 634], [1115, 644], [1109, 643], [1093, 650], [1089, 644], [1079, 645], [1080, 650], [1066, 661]]]
                  }
                }
                ]
              },
              joinBy: 'hc-key'
            }, {
              type: 'mapbubble',
              color: 'rgba(50,158,48,0.2)',
              enableMouseTracking: true,
              data: report.revenue,
              name: 'Revenue',
              mapData: {
                "title": "Australia",
                "version": "1.0.2",
                "type": "FeatureCollection",
                "copyright": "Copyright (c) 2014 Highsoft AS, Based on data from Natural Earth http://www.naturalearthdata.com",
                "copyrightShort": "Natural Earth",
                "copyrightUrl": "http://www.naturalearthdata.com",
                "crs": {
                  "type": "name",
                  "properties": {
                    "name": "urn:ogc:def:crs:EPSG:3112"
                  }
                },
                "features": [{
                  "type": "Feature",
                  "id": "AU.NT",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.65,
                    "hc-middle-y": 0.57,
                    "hc-key": "au-nt",
                    "hc-a2": "NT",
                    "labelrank": "2",
                    "hasc": "AU.NT",
                    "alt-name": null,
                    "woe-id": "2344701",
                    "subregion": null,
                    "fips": "AS03",
                    "postal-code": "NT",
                    "name": "Northern Territory",
                    "country": "Australia",
                    "type-en": "Territory",
                    "region": null,
                    "longitude": "133.78",
                    "woe-name": "Northern Territory",
                    "latitude": "-20.1026",
                    "woe-label": "Northern Territory, AU, Australia",
                    "type": "Territory"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[932, 1724], [936, 1727], [944, 1721], [940, 1711], [951, 1704], [948, 1701], [928, 1706], [928, 1723], [932, 1724]]], [[[663, 1826], [666, 1816], [674, 1812], [649, 1810], [655, 1818], [655, 1825], [661, 1833], [663, 1826]]], [[[668, 1835], [678, 1830], [691, 1832], [700, 1839], [709, 1837], [714, 1827], [704, 1816], [690, 1806], [668, 1818], [662, 1837], [668, 1835]]], [[[992, 1601], [992, 1601], [992, 1600], [979, 1190], [627, 1188], [608, 1673], [608, 1673], [620, 1663], [618, 1675], [629, 1671], [637, 1662], [630, 1677], [643, 1675], [633, 1687], [623, 1694], [630, 1709], [638, 1712], [644, 1738], [655, 1737], [660, 1745], [654, 1751], [654, 1760], [662, 1762], [664, 1774], [672, 1775], [675, 1783], [694, 1787], [692, 1798], [713, 1790], [731, 1794], [737, 1790], [765, 1798], [762, 1820], [751, 1830], [739, 1825], [731, 1834], [724, 1835], [734, 1843], [744, 1831], [743, 1843], [750, 1844], [759, 1835], [755, 1848], [759, 1850], [764, 1826], [773, 1835], [787, 1817], [805, 1814], [814, 1818], [820, 1809], [826, 1811], [842, 1802], [857, 1807], [870, 1793], [883, 1801], [893, 1800], [893, 1806], [910, 1811], [895, 1797], [899, 1790], [906, 1798], [913, 1794], [912, 1784], [922, 1784], [927, 1792], [916, 1801], [931, 1806], [941, 1791], [946, 1797], [951, 1788], [932, 1766], [938, 1761], [931, 1749], [926, 1756], [917, 1748], [905, 1745], [905, 1727], [912, 1731], [920, 1722], [910, 1723], [905, 1707], [899, 1704], [882, 1684], [886, 1674], [919, 1652], [929, 1640], [934, 1648], [938, 1630], [950, 1632], [966, 1620], [982, 1614], [992, 1601]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.WA",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.67,
                    "hc-middle-y": 0.54,
                    "hc-key": "au-wa",
                    "hc-a2": "WA",
                    "labelrank": "2",
                    "hasc": "AU.WA",
                    "alt-name": null,
                    "woe-id": "2344706",
                    "subregion": null,
                    "fips": "AS08",
                    "postal-code": "WA",
                    "name": "Western Australia",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "121.646",
                    "woe-name": "Western Australia",
                    "latitude": "-25.8483",
                    "woe-label": "Western Australia, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[0, 1146], [14, 1124], [7, 1127], [0, 1139], [0, 1146]]], [[[608, 1673], [608, 1673], [627, 1188], [637, 958], [637, 942], [602, 924], [575, 914], [553, 911], [534, 913], [523, 908], [511, 898], [492, 889], [482, 881], [469, 877], [461, 869], [457, 850], [443, 832], [429, 828], [426, 834], [399, 829], [390, 825], [387, 832], [380, 829], [370, 831], [335, 824], [330, 820], [315, 820], [301, 809], [291, 791], [276, 793], [274, 786], [264, 780], [262, 771], [238, 762], [236, 757], [226, 761], [200, 756], [176, 762], [160, 777], [149, 782], [142, 778], [135, 790], [132, 814], [143, 810], [148, 813], [155, 828], [148, 854], [152, 860], [149, 887], [145, 898], [121, 931], [109, 956], [105, 987], [97, 1003], [85, 1015], [82, 1026], [65, 1041], [61, 1059], [54, 1074], [33, 1099], [20, 1109], [22, 1119], [32, 1103], [41, 1104], [42, 1115], [34, 1119], [20, 1138], [24, 1144], [34, 1133], [38, 1120], [41, 1131], [45, 1116], [51, 1112], [53, 1139], [49, 1140], [27, 1166], [20, 1182], [12, 1189], [8, 1210], [12, 1229], [17, 1235], [17, 1255], [7, 1274], [16, 1307], [22, 1311], [21, 1294], [28, 1280], [35, 1283], [42, 1312], [72, 1331], [99, 1365], [107, 1367], [121, 1381], [125, 1374], [135, 1380], [144, 1376], [159, 1381], [174, 1396], [201, 1404], [206, 1413], [215, 1418], [230, 1415], [240, 1421], [257, 1426], [285, 1441], [294, 1449], [306, 1467], [316, 1495], [320, 1495], [335, 1511], [336, 1517], [328, 1517], [325, 1549], [340, 1571], [351, 1572], [348, 1580], [353, 1589], [377, 1550], [384, 1543], [387, 1558], [384, 1566], [396, 1557], [387, 1578], [375, 1587], [387, 1591], [379, 1606], [389, 1604], [387, 1598], [399, 1594], [395, 1601], [414, 1594], [432, 1596], [416, 1598], [423, 1615], [415, 1617], [413, 1633], [423, 1634], [437, 1659], [452, 1652], [456, 1658], [442, 1669], [441, 1681], [446, 1676], [461, 1680], [461, 1694], [465, 1682], [470, 1685], [475, 1676], [480, 1682], [483, 1701], [487, 1696], [496, 1707], [504, 1696], [509, 1716], [518, 1720], [526, 1709], [535, 1712], [549, 1701], [559, 1689], [574, 1679], [569, 1660], [582, 1675], [588, 1677], [608, 1673]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.SA",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.6,
                    "hc-middle-y": 0.26,
                    "hc-key": "au-sa",
                    "hc-a2": "SA",
                    "labelrank": "2",
                    "hasc": "AU.SA",
                    "alt-name": null,
                    "woe-id": "2344703",
                    "subregion": null,
                    "fips": "AS05",
                    "postal-code": "SA",
                    "name": "South Australia",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "135.783",
                    "woe-name": "South Australia",
                    "latitude": "-29.6504",
                    "woe-label": "South Australia, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[953, 774], [951, 768], [968, 766], [967, 759], [957, 762], [946, 753], [937, 757], [920, 754], [913, 761], [915, 767], [943, 775], [953, 774]]], [[[637, 942], [637, 958], [627, 1188], [979, 1190], [1096, 1185], [1089, 1055], [1077, 838], [1076, 839], [1066, 661], [1057, 661], [1045, 670], [1042, 679], [1033, 688], [1025, 701], [1023, 712], [1030, 719], [1030, 726], [1021, 750], [1003, 772], [1007, 776], [1010, 767], [1015, 777], [1012, 783], [1001, 780], [1002, 774], [993, 775], [985, 771], [973, 770], [970, 775], [982, 784], [986, 810], [977, 824], [971, 837], [955, 792], [945, 795], [937, 790], [925, 790], [932, 805], [947, 804], [950, 817], [948, 837], [954, 849], [967, 864], [962, 876], [970, 880], [964, 906], [961, 887], [949, 881], [940, 859], [918, 849], [909, 841], [904, 831], [893, 822], [891, 811], [895, 802], [881, 807], [865, 823], [874, 817], [872, 833], [866, 850], [854, 861], [853, 874], [847, 879], [833, 882], [826, 901], [834, 903], [828, 913], [817, 909], [821, 916], [810, 928], [801, 923], [791, 924], [778, 934], [758, 931], [731, 949], [718, 954], [705, 948], [680, 949], [637, 942]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.ACT",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 3.77,
                    "hc-middle-y": 0.18,
                    "hc-key": "au-ct",
                    "hc-a2": "CT",
                    "labelrank": "9",
                    "hasc": "AU.CT",
                    "alt-name": null,
                    "woe-id": "1100968",
                    "subregion": null,
                    "fips": "AS01",
                    "postal-code": "CT",
                    "name": "Australian Capital Territory",
                    "country": "Australia",
                    "type-en": "Territory",
                    "region": null,
                    "longitude": "148.983",
                    "woe-name": "Canberra",
                    "latitude": "-35.4618",
                    "woe-label": null,
                    "type": "Territory"
                  },
                  "geometry": {
                    "type": "Polygon",
                    "coordinates": [[[1373, 753], [1366, 752], [1361, 743], [1361, 733], [1355, 731], [1350, 740], [1354, 757], [1364, 763], [1373, 753]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.QLD",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.5,
                    "hc-middle-y": 0.6,
                    "hc-key": "au-ql",
                    "hc-a2": "QL",
                    "labelrank": "2",
                    "hasc": "AU.QL",
                    "alt-name": null,
                    "woe-id": "2344702",
                    "subregion": null,
                    "fips": "AS04",
                    "postal-code": "QL",
                    "name": "Queensland",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "144.778",
                    "woe-name": "Queensland",
                    "latitude": "-23.1364",
                    "woe-label": "Queensland, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[1582, 1189], [1584, 1176], [1566, 1145], [1564, 1156], [1570, 1171], [1579, 1180], [1576, 1186], [1582, 1189]]], [[[1502, 1257], [1508, 1252], [1507, 1242], [1499, 1255], [1502, 1257]]], [[[1552, 1035], [1538, 1037], [1529, 1043], [1507, 1034], [1507, 1019], [1489, 1018], [1480, 1010], [1479, 1021], [1462, 1036], [1449, 1037], [1444, 1042], [1433, 1041], [1413, 1044], [1391, 1029], [1089, 1055], [1096, 1185], [979, 1190], [992, 1600], [992, 1601], [1000, 1594], [1020, 1590], [1036, 1583], [1045, 1564], [1075, 1547], [1096, 1549], [1110, 1556], [1122, 1584], [1127, 1588], [1139, 1615], [1137, 1621], [1143, 1641], [1152, 1661], [1147, 1685], [1151, 1703], [1147, 1708], [1149, 1725], [1158, 1739], [1154, 1751], [1165, 1765], [1155, 1771], [1165, 1792], [1171, 1789], [1182, 1823], [1185, 1841], [1198, 1850], [1205, 1848], [1214, 1818], [1213, 1798], [1227, 1791], [1221, 1776], [1235, 1762], [1231, 1751], [1237, 1748], [1239, 1721], [1236, 1711], [1241, 1699], [1244, 1682], [1251, 1676], [1261, 1682], [1264, 1692], [1267, 1684], [1277, 1689], [1282, 1672], [1291, 1669], [1296, 1659], [1309, 1652], [1304, 1646], [1304, 1626], [1310, 1603], [1306, 1586], [1320, 1565], [1327, 1565], [1323, 1558], [1332, 1531], [1324, 1504], [1336, 1504], [1337, 1497], [1332, 1477], [1338, 1468], [1365, 1450], [1378, 1451], [1386, 1429], [1389, 1435], [1396, 1425], [1410, 1421], [1414, 1411], [1421, 1416], [1422, 1408], [1434, 1404], [1422, 1393], [1429, 1380], [1443, 1368], [1449, 1339], [1447, 1336], [1452, 1316], [1467, 1296], [1464, 1312], [1470, 1318], [1475, 1306], [1490, 1295], [1488, 1312], [1496, 1300], [1498, 1290], [1493, 1271], [1493, 1260], [1515, 1230], [1528, 1228], [1539, 1200], [1548, 1193], [1555, 1171], [1564, 1167], [1562, 1147], [1571, 1138], [1564, 1124], [1564, 1090], [1557, 1085], [1566, 1060], [1571, 1074], [1571, 1076], [1571, 1076], [1571, 1076], [1575, 1073], [1567, 1051], [1568, 1041], [1552, 1035]]], [[[1043, 1594], [1047, 1602], [1060, 1605], [1053, 1593], [1043, 1594], [1043, 1594], [1043, 1594]]], [[[1571, 1077], [1571, 1076], [1571, 1076], [1571, 1076], [1570, 1076], [1571, 1077], [1571, 1077]]], [[[1571, 1077], [1570, 1089], [1573, 1090], [1571, 1077], [1571, 1077]]], [[[1043, 1594], [1041, 1587], [1042, 1594], [1043, 1594], [1043, 1594], [1043, 1594]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.TAS",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.81,
                    "hc-middle-y": 0.65,
                    "hc-key": "au-ts",
                    "hc-a2": "TS",
                    "labelrank": "2",
                    "hasc": "AU.TS",
                    "alt-name": null,
                    "woe-id": "2344704",
                    "subregion": null,
                    "fips": "AS06",
                    "postal-code": "TS",
                    "name": "Tasmania",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "146.603",
                    "woe-name": null,
                    "latitude": "-42.1383",
                    "woe-label": null,
                    "type": "State"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[1307, 532], [1300, 538], [1311, 540], [1315, 534], [1307, 532]]], [[[1301, 568], [1311, 555], [1310, 543], [1304, 542], [1293, 561], [1301, 568]]], [[[1167, 565], [1162, 562], [1161, 581], [1169, 584], [1169, 568], [1167, 565]]], [[[1188, 539], [1187, 536], [1200, 528], [1219, 521], [1222, 517], [1242, 509], [1263, 515], [1277, 512], [1283, 519], [1291, 516], [1297, 522], [1307, 509], [1301, 474], [1303, 459], [1296, 463], [1290, 452], [1286, 437], [1284, 411], [1278, 411], [1274, 421], [1281, 419], [1281, 426], [1271, 429], [1272, 424], [1261, 419], [1263, 406], [1255, 411], [1245, 396], [1236, 402], [1225, 405], [1219, 403], [1217, 419], [1213, 415], [1210, 427], [1204, 431], [1198, 448], [1197, 466], [1204, 458], [1198, 477], [1190, 489], [1182, 522], [1188, 539]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.NSW",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.64,
                    "hc-middle-y": 0.29,
                    "hc-key": "au-ns",
                    "hc-a2": "NS",
                    "labelrank": "2",
                    "hasc": "AU.NS",
                    "alt-name": null,
                    "woe-id": "2344700",
                    "subregion": null,
                    "fips": "AS02",
                    "postal-code": "NS",
                    "name": "New South Wales",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "146.781",
                    "woe-name": "New South Wales",
                    "latitude": "-32.4751",
                    "woe-label": "New South Wales, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "Polygon",
                    "coordinates": [[[1418, 754], [1398, 726], [1395, 707], [1383, 682], [1386, 666], [1382, 656], [1324, 694], [1325, 701], [1320, 728], [1311, 734], [1300, 734], [1297, 729], [1279, 730], [1272, 736], [1263, 734], [1241, 740], [1235, 746], [1215, 747], [1214, 737], [1205, 736], [1194, 746], [1191, 754], [1160, 781], [1160, 798], [1138, 808], [1131, 801], [1126, 812], [1127, 820], [1121, 827], [1104, 832], [1097, 828], [1077, 838], [1089, 1055], [1391, 1029], [1413, 1044], [1433, 1041], [1444, 1042], [1449, 1037], [1462, 1036], [1479, 1021], [1480, 1010], [1489, 1018], [1507, 1019], [1507, 1034], [1529, 1043], [1538, 1037], [1552, 1035], [1568, 1041], [1570, 1036], [1567, 1010], [1554, 992], [1551, 976], [1531, 934], [1534, 926], [1525, 902], [1505, 875], [1504, 863], [1486, 850], [1476, 848], [1453, 819], [1449, 804], [1434, 790], [1428, 771], [1427, 761], [1421, 757], [1419, 756], [1418, 754]], [[1373, 753], [1364, 763], [1354, 757], [1350, 740], [1355, 731], [1361, 733], [1361, 743], [1366, 752], [1373, 753]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.VIC",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.58,
                    "hc-middle-y": 0.72,
                    "hc-key": "au-vi",
                    "hc-a2": "VI",
                    "labelrank": "2",
                    "hasc": "AU.VI",
                    "alt-name": null,
                    "woe-id": "2344705",
                    "subregion": null,
                    "fips": "AS07",
                    "postal-code": "VI",
                    "name": "Victoria",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "144.75",
                    "woe-name": "Victoria",
                    "latitude": "-37.0082",
                    "woe-label": "Victoria, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "Polygon",
                    "coordinates": [[[1066, 661], [1076, 839], [1077, 838], [1097, 828], [1104, 832], [1121, 827], [1127, 820], [1126, 812], [1131, 801], [1138, 808], [1160, 798], [1160, 781], [1191, 754], [1194, 746], [1205, 736], [1214, 737], [1215, 747], [1235, 746], [1241, 740], [1263, 734], [1272, 736], [1279, 730], [1297, 729], [1300, 734], [1311, 734], [1320, 728], [1325, 701], [1324, 694], [1382, 656], [1375, 655], [1363, 646], [1322, 649], [1308, 647], [1296, 641], [1269, 619], [1245, 616], [1248, 609], [1255, 614], [1251, 598], [1241, 614], [1235, 610], [1232, 622], [1209, 629], [1215, 635], [1216, 642], [1203, 631], [1198, 637], [1205, 638], [1210, 646], [1206, 658], [1201, 658], [1190, 650], [1197, 647], [1194, 642], [1185, 642], [1172, 635], [1164, 626], [1153, 619], [1137, 631], [1129, 634], [1115, 644], [1109, 643], [1093, 650], [1089, 644], [1079, 645], [1080, 650], [1066, 661]]]
                  }
                }
                ]
              },
              joinBy: 'hc-key',
              dataLabels: {
                enabled: true,
                style: {
                  textShadow: 'none',
                  color: '#fff',
                  fontSize: '1.3em',
                  fontFamily: 'ff-enzo-web'
                },
                formatter () {
                  return this.point.value + '%'
                }
              }
            }, {
              type: 'mapbubble',
              color: 'rgba(67,90,204,0.5)',
              enableMouseTracking: true,
              data: report.attendance,
              name: 'Attendance',
              mapData: {
                "title": "Australia",
                "version": "1.0.2",
                "type": "FeatureCollection",
                "copyright": "Copyright (c) 2014 Highsoft AS, Based on data from Natural Earth http://www.naturalearthdata.com",
                "copyrightShort": "Natural Earth",
                "copyrightUrl": "http://www.naturalearthdata.com",
                "crs": {
                  "type": "name",
                  "properties": {
                    "name": "urn:ogc:def:crs:EPSG:3112"
                  }
                },
                "features": [{
                  "type": "Feature",
                  "id": "AU.NT",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.45,
                    "hc-middle-y": 0.57,
                    "hc-key": "au-nt",
                    "hc-a2": "NT",
                    "labelrank": "2",
                    "hasc": "AU.NT",
                    "alt-name": null,
                    "woe-id": "2344701",
                    "subregion": null,
                    "fips": "AS03",
                    "postal-code": "NT",
                    "name": "Northern Territory",
                    "country": "Australia",
                    "type-en": "Territory",
                    "region": null,
                    "longitude": "133.78",
                    "woe-name": "Northern Territory",
                    "latitude": "-20.1026",
                    "woe-label": "Northern Territory, AU, Australia",
                    "type": "Territory"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[932, 1724], [936, 1727], [944, 1721], [940, 1711], [951, 1704], [948, 1701], [928, 1706], [928, 1723], [932, 1724]]], [[[663, 1826], [666, 1816], [674, 1812], [649, 1810], [655, 1818], [655, 1825], [661, 1833], [663, 1826]]], [[[668, 1835], [678, 1830], [691, 1832], [700, 1839], [709, 1837], [714, 1827], [704, 1816], [690, 1806], [668, 1818], [662, 1837], [668, 1835]]], [[[992, 1601], [992, 1601], [992, 1600], [979, 1190], [627, 1188], [608, 1673], [608, 1673], [620, 1663], [618, 1675], [629, 1671], [637, 1662], [630, 1677], [643, 1675], [633, 1687], [623, 1694], [630, 1709], [638, 1712], [644, 1738], [655, 1737], [660, 1745], [654, 1751], [654, 1760], [662, 1762], [664, 1774], [672, 1775], [675, 1783], [694, 1787], [692, 1798], [713, 1790], [731, 1794], [737, 1790], [765, 1798], [762, 1820], [751, 1830], [739, 1825], [731, 1834], [724, 1835], [734, 1843], [744, 1831], [743, 1843], [750, 1844], [759, 1835], [755, 1848], [759, 1850], [764, 1826], [773, 1835], [787, 1817], [805, 1814], [814, 1818], [820, 1809], [826, 1811], [842, 1802], [857, 1807], [870, 1793], [883, 1801], [893, 1800], [893, 1806], [910, 1811], [895, 1797], [899, 1790], [906, 1798], [913, 1794], [912, 1784], [922, 1784], [927, 1792], [916, 1801], [931, 1806], [941, 1791], [946, 1797], [951, 1788], [932, 1766], [938, 1761], [931, 1749], [926, 1756], [917, 1748], [905, 1745], [905, 1727], [912, 1731], [920, 1722], [910, 1723], [905, 1707], [899, 1704], [882, 1684], [886, 1674], [919, 1652], [929, 1640], [934, 1648], [938, 1630], [950, 1632], [966, 1620], [982, 1614], [992, 1601]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.WA",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.47,
                    "hc-middle-y": 0.54,
                    "hc-key": "au-wa",
                    "hc-a2": "WA",
                    "labelrank": "2",
                    "hasc": "AU.WA",
                    "alt-name": null,
                    "woe-id": "2344706",
                    "subregion": null,
                    "fips": "AS08",
                    "postal-code": "WA",
                    "name": "Western Australia",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "121.646",
                    "woe-name": "Western Australia",
                    "latitude": "-25.8483",
                    "woe-label": "Western Australia, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[0, 1146], [14, 1124], [7, 1127], [0, 1139], [0, 1146]]], [[[608, 1673], [608, 1673], [627, 1188], [637, 958], [637, 942], [602, 924], [575, 914], [553, 911], [534, 913], [523, 908], [511, 898], [492, 889], [482, 881], [469, 877], [461, 869], [457, 850], [443, 832], [429, 828], [426, 834], [399, 829], [390, 825], [387, 832], [380, 829], [370, 831], [335, 824], [330, 820], [315, 820], [301, 809], [291, 791], [276, 793], [274, 786], [264, 780], [262, 771], [238, 762], [236, 757], [226, 761], [200, 756], [176, 762], [160, 777], [149, 782], [142, 778], [135, 790], [132, 814], [143, 810], [148, 813], [155, 828], [148, 854], [152, 860], [149, 887], [145, 898], [121, 931], [109, 956], [105, 987], [97, 1003], [85, 1015], [82, 1026], [65, 1041], [61, 1059], [54, 1074], [33, 1099], [20, 1109], [22, 1119], [32, 1103], [41, 1104], [42, 1115], [34, 1119], [20, 1138], [24, 1144], [34, 1133], [38, 1120], [41, 1131], [45, 1116], [51, 1112], [53, 1139], [49, 1140], [27, 1166], [20, 1182], [12, 1189], [8, 1210], [12, 1229], [17, 1235], [17, 1255], [7, 1274], [16, 1307], [22, 1311], [21, 1294], [28, 1280], [35, 1283], [42, 1312], [72, 1331], [99, 1365], [107, 1367], [121, 1381], [125, 1374], [135, 1380], [144, 1376], [159, 1381], [174, 1396], [201, 1404], [206, 1413], [215, 1418], [230, 1415], [240, 1421], [257, 1426], [285, 1441], [294, 1449], [306, 1467], [316, 1495], [320, 1495], [335, 1511], [336, 1517], [328, 1517], [325, 1549], [340, 1571], [351, 1572], [348, 1580], [353, 1589], [377, 1550], [384, 1543], [387, 1558], [384, 1566], [396, 1557], [387, 1578], [375, 1587], [387, 1591], [379, 1606], [389, 1604], [387, 1598], [399, 1594], [395, 1601], [414, 1594], [432, 1596], [416, 1598], [423, 1615], [415, 1617], [413, 1633], [423, 1634], [437, 1659], [452, 1652], [456, 1658], [442, 1669], [441, 1681], [446, 1676], [461, 1680], [461, 1694], [465, 1682], [470, 1685], [475, 1676], [480, 1682], [483, 1701], [487, 1696], [496, 1707], [504, 1696], [509, 1716], [518, 1720], [526, 1709], [535, 1712], [549, 1701], [559, 1689], [574, 1679], [569, 1660], [582, 1675], [588, 1677], [608, 1673]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.SA",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.34,
                    "hc-middle-y": 0.26,
                    "hc-key": "au-sa",
                    "hc-a2": "SA",
                    "labelrank": "2",
                    "hasc": "AU.SA",
                    "alt-name": null,
                    "woe-id": "2344703",
                    "subregion": null,
                    "fips": "AS05",
                    "postal-code": "SA",
                    "name": "South Australia",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "135.783",
                    "woe-name": "South Australia",
                    "latitude": "-29.6504",
                    "woe-label": "South Australia, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[953, 774], [951, 768], [968, 766], [967, 759], [957, 762], [946, 753], [937, 757], [920, 754], [913, 761], [915, 767], [943, 775], [953, 774]]], [[[637, 942], [637, 958], [627, 1188], [979, 1190], [1096, 1185], [1089, 1055], [1077, 838], [1076, 839], [1066, 661], [1057, 661], [1045, 670], [1042, 679], [1033, 688], [1025, 701], [1023, 712], [1030, 719], [1030, 726], [1021, 750], [1003, 772], [1007, 776], [1010, 767], [1015, 777], [1012, 783], [1001, 780], [1002, 774], [993, 775], [985, 771], [973, 770], [970, 775], [982, 784], [986, 810], [977, 824], [971, 837], [955, 792], [945, 795], [937, 790], [925, 790], [932, 805], [947, 804], [950, 817], [948, 837], [954, 849], [967, 864], [962, 876], [970, 880], [964, 906], [961, 887], [949, 881], [940, 859], [918, 849], [909, 841], [904, 831], [893, 822], [891, 811], [895, 802], [881, 807], [865, 823], [874, 817], [872, 833], [866, 850], [854, 861], [853, 874], [847, 879], [833, 882], [826, 901], [834, 903], [828, 913], [817, 909], [821, 916], [810, 928], [801, 923], [791, 924], [778, 934], [758, 931], [731, 949], [718, 954], [705, 948], [680, 949], [637, 942]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.ACT",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.17,
                    "hc-middle-y": 0.18,
                    "hc-key": "au-ct",
                    "hc-a2": "CT",
                    "labelrank": "9",
                    "hasc": "AU.CT",
                    "alt-name": null,
                    "woe-id": "1100968",
                    "subregion": null,
                    "fips": "AS01",
                    "postal-code": "CT",
                    "name": "Australian Capital Territory",
                    "country": "Australia",
                    "type-en": "Territory",
                    "region": null,
                    "longitude": "148.983",
                    "woe-name": "Canberra",
                    "latitude": "-35.4618",
                    "woe-label": null,
                    "type": "Territory"
                  },
                  "geometry": {
                    "type": "Polygon",
                    "coordinates": [[[1373, 753], [1366, 752], [1361, 743], [1361, 733], [1355, 731], [1350, 740], [1354, 757], [1364, 763], [1373, 753]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.QLD",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.3,
                    "hc-middle-y": 0.6,
                    "hc-key": "au-ql",
                    "hc-a2": "QL",
                    "labelrank": "2",
                    "hasc": "AU.QL",
                    "alt-name": null,
                    "woe-id": "2344702",
                    "subregion": null,
                    "fips": "AS04",
                    "postal-code": "QL",
                    "name": "Queensland",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "144.778",
                    "woe-name": "Queensland",
                    "latitude": "-23.1364",
                    "woe-label": "Queensland, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[1582, 1189], [1584, 1176], [1566, 1145], [1564, 1156], [1570, 1171], [1579, 1180], [1576, 1186], [1582, 1189]]], [[[1502, 1257], [1508, 1252], [1507, 1242], [1499, 1255], [1502, 1257]]], [[[1552, 1035], [1538, 1037], [1529, 1043], [1507, 1034], [1507, 1019], [1489, 1018], [1480, 1010], [1479, 1021], [1462, 1036], [1449, 1037], [1444, 1042], [1433, 1041], [1413, 1044], [1391, 1029], [1089, 1055], [1096, 1185], [979, 1190], [992, 1600], [992, 1601], [1000, 1594], [1020, 1590], [1036, 1583], [1045, 1564], [1075, 1547], [1096, 1549], [1110, 1556], [1122, 1584], [1127, 1588], [1139, 1615], [1137, 1621], [1143, 1641], [1152, 1661], [1147, 1685], [1151, 1703], [1147, 1708], [1149, 1725], [1158, 1739], [1154, 1751], [1165, 1765], [1155, 1771], [1165, 1792], [1171, 1789], [1182, 1823], [1185, 1841], [1198, 1850], [1205, 1848], [1214, 1818], [1213, 1798], [1227, 1791], [1221, 1776], [1235, 1762], [1231, 1751], [1237, 1748], [1239, 1721], [1236, 1711], [1241, 1699], [1244, 1682], [1251, 1676], [1261, 1682], [1264, 1692], [1267, 1684], [1277, 1689], [1282, 1672], [1291, 1669], [1296, 1659], [1309, 1652], [1304, 1646], [1304, 1626], [1310, 1603], [1306, 1586], [1320, 1565], [1327, 1565], [1323, 1558], [1332, 1531], [1324, 1504], [1336, 1504], [1337, 1497], [1332, 1477], [1338, 1468], [1365, 1450], [1378, 1451], [1386, 1429], [1389, 1435], [1396, 1425], [1410, 1421], [1414, 1411], [1421, 1416], [1422, 1408], [1434, 1404], [1422, 1393], [1429, 1380], [1443, 1368], [1449, 1339], [1447, 1336], [1452, 1316], [1467, 1296], [1464, 1312], [1470, 1318], [1475, 1306], [1490, 1295], [1488, 1312], [1496, 1300], [1498, 1290], [1493, 1271], [1493, 1260], [1515, 1230], [1528, 1228], [1539, 1200], [1548, 1193], [1555, 1171], [1564, 1167], [1562, 1147], [1571, 1138], [1564, 1124], [1564, 1090], [1557, 1085], [1566, 1060], [1571, 1074], [1571, 1076], [1571, 1076], [1571, 1076], [1575, 1073], [1567, 1051], [1568, 1041], [1552, 1035]]], [[[1043, 1594], [1047, 1602], [1060, 1605], [1053, 1593], [1043, 1594], [1043, 1594], [1043, 1594]]], [[[1571, 1077], [1571, 1076], [1571, 1076], [1571, 1076], [1570, 1076], [1571, 1077], [1571, 1077]]], [[[1571, 1077], [1570, 1089], [1573, 1090], [1571, 1077], [1571, 1077]]], [[[1043, 1594], [1041, 1587], [1042, 1594], [1043, 1594], [1043, 1594], [1043, 1594]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.TAS",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.30,
                    "hc-middle-y": 0.65,
                    "hc-key": "au-ts",
                    "hc-a2": "TS",
                    "labelrank": "2",
                    "hasc": "AU.TS",
                    "alt-name": null,
                    "woe-id": "2344704",
                    "subregion": null,
                    "fips": "AS06",
                    "postal-code": "TS",
                    "name": "Tasmania",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "146.603",
                    "woe-name": null,
                    "latitude": "-42.1383",
                    "woe-label": null,
                    "type": "State"
                  },
                  "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [[[[1307, 532], [1300, 538], [1311, 540], [1315, 534], [1307, 532]]], [[[1301, 568], [1311, 555], [1310, 543], [1304, 542], [1293, 561], [1301, 568]]], [[[1167, 565], [1162, 562], [1161, 581], [1169, 584], [1169, 568], [1167, 565]]], [[[1188, 539], [1187, 536], [1200, 528], [1219, 521], [1222, 517], [1242, 509], [1263, 515], [1277, 512], [1283, 519], [1291, 516], [1297, 522], [1307, 509], [1301, 474], [1303, 459], [1296, 463], [1290, 452], [1286, 437], [1284, 411], [1278, 411], [1274, 421], [1281, 419], [1281, 426], [1271, 429], [1272, 424], [1261, 419], [1263, 406], [1255, 411], [1245, 396], [1236, 402], [1225, 405], [1219, 403], [1217, 419], [1213, 415], [1210, 427], [1204, 431], [1198, 448], [1197, 466], [1204, 458], [1198, 477], [1190, 489], [1182, 522], [1188, 539]]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.NSW",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.24,
                    "hc-middle-y": 0.29,
                    "hc-key": "au-ns",
                    "hc-a2": "NS",
                    "labelrank": "2",
                    "hasc": "AU.NS",
                    "alt-name": null,
                    "woe-id": "2344700",
                    "subregion": null,
                    "fips": "AS02",
                    "postal-code": "NS",
                    "name": "New South Wales",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "146.781",
                    "woe-name": "New South Wales",
                    "latitude": "-32.4751",
                    "woe-label": "New South Wales, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "Polygon",
                    "coordinates": [[[1418, 754], [1398, 726], [1395, 707], [1383, 682], [1386, 666], [1382, 656], [1324, 694], [1325, 701], [1320, 728], [1311, 734], [1300, 734], [1297, 729], [1279, 730], [1272, 736], [1263, 734], [1241, 740], [1235, 746], [1215, 747], [1214, 737], [1205, 736], [1194, 746], [1191, 754], [1160, 781], [1160, 798], [1138, 808], [1131, 801], [1126, 812], [1127, 820], [1121, 827], [1104, 832], [1097, 828], [1077, 838], [1089, 1055], [1391, 1029], [1413, 1044], [1433, 1041], [1444, 1042], [1449, 1037], [1462, 1036], [1479, 1021], [1480, 1010], [1489, 1018], [1507, 1019], [1507, 1034], [1529, 1043], [1538, 1037], [1552, 1035], [1568, 1041], [1570, 1036], [1567, 1010], [1554, 992], [1551, 976], [1531, 934], [1534, 926], [1525, 902], [1505, 875], [1504, 863], [1486, 850], [1476, 848], [1453, 819], [1449, 804], [1434, 790], [1428, 771], [1427, 761], [1421, 757], [1419, 756], [1418, 754]], [[1373, 753], [1364, 763], [1354, 757], [1350, 740], [1355, 731], [1361, 733], [1361, 743], [1366, 752], [1373, 753]]]
                  }
                }, {
                  "type": "Feature",
                  "id": "AU.VIC",
                  "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.08,
                    "hc-middle-y": 0.72,
                    "hc-key": "au-vi",
                    "hc-a2": "VI",
                    "labelrank": "2",
                    "hasc": "AU.VI",
                    "alt-name": null,
                    "woe-id": "2344705",
                    "subregion": null,
                    "fips": "AS07",
                    "postal-code": "VI",
                    "name": "Victoria",
                    "country": "Australia",
                    "type-en": "State",
                    "region": null,
                    "longitude": "144.75",
                    "woe-name": "Victoria",
                    "latitude": "-37.0082",
                    "woe-label": "Victoria, AU, Australia",
                    "type": "State"
                  },
                  "geometry": {
                    "type": "Polygon",
                    "coordinates": [[[1066, 661], [1076, 839], [1077, 838], [1097, 828], [1104, 832], [1121, 827], [1127, 820], [1126, 812], [1131, 801], [1138, 808], [1160, 798], [1160, 781], [1191, 754], [1194, 746], [1205, 736], [1214, 737], [1215, 747], [1235, 746], [1241, 740], [1263, 734], [1272, 736], [1279, 730], [1297, 729], [1300, 734], [1311, 734], [1320, 728], [1325, 701], [1324, 694], [1382, 656], [1375, 655], [1363, 646], [1322, 649], [1308, 647], [1296, 641], [1269, 619], [1245, 616], [1248, 609], [1255, 614], [1251, 598], [1241, 614], [1235, 610], [1232, 622], [1209, 629], [1215, 635], [1216, 642], [1203, 631], [1198, 637], [1205, 638], [1210, 646], [1206, 658], [1201, 658], [1190, 650], [1197, 647], [1194, 642], [1185, 642], [1172, 635], [1164, 626], [1153, 619], [1137, 631], [1129, 634], [1115, 644], [1109, 643], [1093, 650], [1089, 644], [1079, 645], [1080, 650], [1066, 661]]]
                  }
                }
                ]
              },
              joinBy: ['hc-key'],
              dataLabels: {
                enabled: true,
                style: {
                  textShadow: 'none',
                  color: '#fff',
                  fontSize: '1.3em',
                  fontFamily: 'ff-enzo-web'
                },
                formatter () {
                  return this.point.value + '%'
                }
              }
            }]
          }
        }
      }

      return false
    }
  }
}

</script>

<style lang="scss" scoped="scoped">
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
    @media (max-width: 768px) {
      position: unset;
    }
  }
}

svg#fish {
  top: 5em;
}
/* Fish Animation */
svg.fish{
  overflow: hidden;
}

@-webkit-keyframes swim
{
  0% {margin-left: -235px}
  90% {margin-left: 100%;}
  100% {margin-left: 100%;}
}

@keyframes swim
{
  0% {margin-left: -235px}
  70% {margin-left: 100%;}
  100% {margin-left: 100%;}
}

.fish{
  left: 0;
  width: 235px;
  height: 70px;
  margin-left: -235px;
  position: absolute;
  animation: swim 20s;
  -webkit-animation: swim 20s;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  animation-timing-function: linear;
  -webkit-animation-timing-function: linear;
}

svg #fish1,
svg #fish2,
svg #fish3,
svg #fish4,
svg #fish5,
svg #fish6 {
  fill:#183a70;

  -moz-animation: bounce 2s infinite;
  -webkit-animation: bounce 2s infinite;
  animation: bounce 2s infinite;
}

svg #fish2{
  animation-delay: 0.5s;
  -webkit-animation-delay: 0.5s;
}

svg #fish3{
  animation-delay: 0.2s;
  -webkit-animation-delay: 0.2s;
}

svg #fish4{
  animation-delay: 0.4s;
  -webkit-animation-delay: 0.4s;
}

svg #fish5{
  animation-delay: 0.1s;
  -webkit-animation-delay: 0.1s;
}

svg #fish6{
  animation-delay: 0.3s;
  -webkit-animation-delay: 0.3s;
}

/**/
@-moz-keyframes bounce {
  0%, 50%, 100% {
    -moz-transform: translateY(0);
    transform: translateY(0);
  }
  25% {
    -moz-transform: translateY(-5px);
    transform: translateY(-5px);
  }
  75% {
    -moz-transform: translateY(-3px);
    transform: translateY(-3px);
  }
}
@-webkit-keyframes bounce {
  0%, 50%, 100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  25% {
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
  }
  75% {
    -webkit-transform: translateY(-3px);
    transform: translateY(-3px);
  }
}
@keyframes bounce {
  0%, 50%, 100% {
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  25% {
    -moz-transform: translateY(-5px);
    -ms-transform: translateY(-5px);
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
  }
  75% {
    -moz-transform: translateY(-3px);
    -ms-transform: translateY(-3px);
    -webkit-transform: translateY(-3px);
    transform: translateY(-3px);
  }
}

.fish-ani {
  position: absolute;
  width: 100%;
  height: 100px;
  overflow: hidden;
}
.footnotes {
  font-size: .8em;
}
.divider {
  border-width: 1px 0 0;
  border-style: solid;
  border-color: rgba(255, 255, 255, .5);
  margin: 1em 0;
}
</style>
